import { IResult } from '../models/HttpResult';
import { ContractConcept } from '../models/Entities/Contracts/ContractConcept';
import { NewContractConcept } from '../models/Entities/Contracts/NewContractConcept';
import { NewConcept } from '../models/Entities/Contracts/NewConcept';
import { Concept } from '../models/Entities/Contracts/Concept';

//Functions
import * as Functions from '../functions/common';

// Error Tracer
import * as Sentry from '@sentry/react';
import { useSelector } from 'react-redux';


const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'contracts/';
const BaseURLConcept = process.env.REACT_APP_BILLER_API_GATEWAY + 'concepts/';

// Get All Concepts of contract
export const GetContractsConcept = async (ContractId: number, referralDate: Date | undefined, token: string): Promise<ContractConcept[]> => {

    let RequestURL: string = BaseURL + ContractId + '/concepts/?referralDate=' + (referralDate ? new Date(referralDate).toISOString() : '');
    try {
        const Response: ContractConcept[] = await fetch(RequestURL, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        }
        })
        .then((response) => {
            if (!response.ok) {
            Sentry.captureException(response);
            throw response;
            } else {
            return response.json() as Promise<IResult<ContractConcept[]>>;
            }
        })
        .then((data: IResult<ContractConcept[]>) => {
            console.log(data.data);
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        Sentry.captureException(error);
        throw error;
    }
};

// Get All Concepts by addendum id

export const GetContractConceptsByAddendumId = async (AddendumId: number, token: string): Promise<ContractConcept[]> => {

    let RequestURL: string = BaseURL + 'addendums/' + AddendumId + '/concepts/';

    try {
        const Response: ContractConcept[] = await fetch(RequestURL, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        }
        })
        .then((response) => {
            if (!response.ok) {
            Sentry.captureException(response);
            throw response;
            } else {
            return response.json() as Promise<IResult<ContractConcept[]>>;
            }
        })
        .then((data: IResult<ContractConcept[]>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        Sentry.captureException(error);
        throw error;
    }
};

// Get contract By Id
export const GetContractConceptById = async (id: number, token: string): Promise<ContractConcept> => {

    let RequestURL: string = BaseURL + 'concepts/' + id;
    
    try {
        const Response: ContractConcept = await fetch(RequestURL, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        }
        })
        .then((response) => {
            if (!response.ok) {
            Sentry.captureException(response);
            throw response;
            } else {
            return response.json() as Promise<IResult<ContractConcept>>;
            }
        })
        .then((data: IResult<ContractConcept>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );
    
        return Response;
    } catch (error: any) {
        Sentry.captureException(error);
        throw error;
    }
    };

// Create concept
export const CreateConcept = async (newConcept: NewConcept, token: string): Promise<Concept> => {

    let RequestURL: string = BaseURLConcept;
    
    try {
        const Response: Concept = await fetch(RequestURL, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        },
        body: JSON.stringify(newConcept)
        })
        .then((response) => {
            if (!response.ok) {
            Sentry.captureException(response);
            throw response;
            } else {
            return response.json() as Promise<IResult<Concept>>;
            }
        })
        .then((data: IResult<Concept>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );
    
        return Response;
    } catch (error: any) {
        Sentry.captureException(error);
        throw error;
    }
};

// Update Concept
export const UpdateConcept = async (concept: Concept, token: string): Promise<Concept> => {

    let RequestURL: string = BaseURLConcept;
    
    try {
        const Response: Concept = await fetch(RequestURL, {
        method: 'PUT',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        },
        body: JSON.stringify(concept)
        })
        .then((response) => {
            if (!response.ok) {
            Sentry.captureException(response);
            throw response;
            } else {
            return response.json() as Promise<IResult<Concept>>;
            }
        })
        .then((data: IResult<Concept>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );
    
        return Response;
    } catch (error: any) {
        Sentry.captureException(error);
        throw error;
    }
};


// Create Contract concept
export const CreateContractConcept = async (newContractConcept: NewContractConcept, token: string): Promise<ContractConcept> => {

    let RequestURL: string = BaseURL + 'concepts/';
    
    try {
        const Response: ContractConcept = await fetch(RequestURL, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        },
        body: JSON.stringify(newContractConcept)
        })
        .then((response) => {
            if (!response.ok) {
            Sentry.captureException(response);
            throw response;
            } else {
            return response.json() as Promise<IResult<ContractConcept>>;
            }
        })
        .then((data: IResult<ContractConcept>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );
    
        return Response;
    } catch (error: any) {
        Sentry.captureException(error);
        throw error;
    }
    };

// Update Contract
export const UpdateContractConcept = async (contractConcept: ContractConcept, token: string): Promise<ContractConcept> => {

    let RequestURL: string = BaseURL + 'concepts/';
    
    try {
        const Response: ContractConcept = await fetch(RequestURL, {
        method: 'PUT',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        },
        body: JSON.stringify(contractConcept)
        })
        .then((response) => {
            if (!response.ok) {
            Sentry.captureException(response);
            throw response;
            } else {
            return response.json() as Promise<IResult<ContractConcept>>;
            }
        })
        .then((data: IResult<ContractConcept>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );
    
        return Response;
    } catch (error: any) {
        Sentry.captureException(error);
        throw error;
    }
};

// Delete contract concept
export const DeleteContractConcept = async (id: number, token: string): Promise<boolean> => {

    let RequestURL: string = BaseURL + 'concepts/' + id;
    
    try {
        const Response: boolean = await fetch(RequestURL, {
        method: 'DELETE',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        }
        })
        .then((response) => {
            if (!response.ok) {
            Sentry.captureException(response);
            throw response;
            } else {
            return response.json() as Promise<IResult<boolean>>;
            }
        })
        .then((data: IResult<boolean>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );
    
        return Response;
    } catch (error: any) {
        Sentry.captureException(error);
        throw error;
    }
};

// Clone contract concept
export const CloneContractConcept = async (contractConceptId: number, token: string): Promise<ContractConcept> => {

    const RequestURL: string = BaseURL + 'concepts/' + contractConceptId + '/clone';

    try {
        const Response: ContractConcept = await fetch(RequestURL, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            }
        })
        .then((response) => {
            if (!response.ok) {
                Sentry.captureException(response);
                throw response;
            } else {
                return response.json() as Promise<IResult<ContractConcept>>;
            }
        })
        .then((data: IResult<ContractConcept>) => data.data)
        .catch((error: any) =>
            error.text().then((body: any) => {
                throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        Sentry.captureException(error);
        throw error;
    }
};

// Enable / disable a contract concept
export const SetContractConceptEnabled = async (contractConceptId: number, enabled: boolean, token: string): Promise<number> => {

    // Swagger: PATCH /contracts/concepts/{ContractConceptId}/enabled/{Enabled}
    let RequestURL: string = BaseURL + 'concepts/' + contractConceptId.toString() + '/enabled/' + enabled.toString();

    try {
        const Response: number = await fetch(RequestURL, {
            method: 'PATCH',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            }
        })
            .then((response) => {
                if (!response.ok) {
                    Sentry.captureException(response);
                    throw response;
                } else {
                    return response.json() as Promise<IResult<number>>;
                }
            })
            .then((data: IResult<number>) => {
                return data.data;
            })
            .catch((error: any) =>
                error.text().then((body: any) => {
                    throw Functions.HttpErrorHandler(body, error);
                })
            );

        return Response;
    } catch (error: any) {
        Sentry.captureException(error);
        throw error;
    }
};

// Approve / unapprove a contract concept
export const SetContractConceptApproved = async (contractConceptId: number, approved: boolean, token: string): Promise<number> => {

    // Swagger: PATCH /contracts/concepts/{ContractConceptId}/approved/{Approved}
    let RequestURL: string = BaseURL + 'concepts/' + contractConceptId.toString() + '/approved/' + approved.toString();

    try {
        const Response: number = await fetch(RequestURL, {
            method: 'PATCH',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            }
        })
            .then((response) => {
                if (!response.ok) {
                    Sentry.captureException(response);
                    throw response;
                } else {
                    return response.json() as Promise<IResult<number>>;
                }
            })
            .then((data: IResult<number>) => {
                return data.data;
            })
            .catch((error: any) =>
                error.text().then((body: any) => {
                    throw Functions.HttpErrorHandler(body, error);
                })
            );

        return Response;
    } catch (error: any) {
        Sentry.captureException(error);
        throw error;
    }
};
